import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSquareArrowCenter: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconSquareArrowCenter"><Path fillRule="evenodd" clipRule="evenodd" d="M3 3L21 3V14H19.5V4.5L4.5 4.5L4.5 19.5H14V21H3L3 3ZM9 9H16V10.5H11.5607L19.0607 18L18 19.0607L10.5 11.5607V16H9V9Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSquareArrowCenter;
